import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiDownload } from "react-icons/fi";

import icon_26 from "../assets/figma/inclusion.svg";
import sustainabilityCenter from "../assets/figma/sustainability-center.svg";
import sustainabilityLeft from "../assets/figma/sustainability-left.svg";
import sustainabilityRight from "../assets/figma/sustainability-right.svg";
import icon_3 from "../assets/figma/innovation.svg";
import icon_28 from "../assets/figma/value-transparency.svg";
import icon_29 from "../assets/figma/concreteness.svg";

import teamPhoto from "../assets/figma/team.png";

import GroupChart from "../components/GroupChart";
import rigsaveCapitalLogo from "../assets/figma/capital-logo.svg";




import { openS3Document } from "../lib/documents";

function AboutUs() {
  const { t } = useTranslation();
  const location = useLocation();

  const files = useMemo(
    () => [
      {
        name: t("main.aboutUs.downloads.companyData"),
        key: "generic/Company_Data-RIGSAVE-SPA.pdf",
      },
      {
        name: t("main.aboutUs.downloads.informationMemorandum"),
        key: "generic/infomemo-Rigsave-SpA-eng.pdf",
      },
      {
        name: t("main.aboutUs.downloads.inclusionDocument"),
        key: "generic/Rigsave_Inclusion_Document.pdf",
      },
      {
        name: t("main.aboutUs.downloads.ethicalCode"),
        key: "ethical_code/A8_codice_etico.pdf",
      },
      {
        name: t("main.aboutUs.downloads.model231_5"),
        key: "model_231/A6.pdf",
      },
    ],
    [t]
  );

  const values = useMemo(
    () => [
      {
        icon: icon_26,
        title: t("main.aboutUs.values.inclusion.title"),
        text: t("main.aboutUs.values.inclusion.text"),
        mobileText: t("main.aboutUs.values.inclusion.mobileText"),
      },
      {
        icon: icon_28,
        title: t("main.aboutUs.values.transparency.title"),
        text: t("main.aboutUs.values.transparency.text"),
        mobileText: t("main.aboutUs.values.transparency.mobileText"),
      },
      {
        icon: icon_29,
        title: t("main.aboutUs.values.concreteness.title"),
        text: t("main.aboutUs.values.concreteness.text"),
        mobileText: t("main.aboutUs.values.concreteness.mobileText"),
      },
      {
        icon: null,
        title: t("main.aboutUs.values.sustainability.title"),
        text: t("main.aboutUs.values.sustainability.text"),
        mobileText: t("main.aboutUs.values.sustainability.mobileText"),
      },
      {
        icon: icon_3,
        title: t("main.aboutUs.values.innovation.title"),
        text: t("main.aboutUs.values.innovation.text"),
        mobileText: t("main.aboutUs.values.innovation.mobileText"),
      },
    ],
    [t]
  );

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace("#", ""));

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  }, [location]);

  return (
    <main className="about-us-page">
      <section className="about-hero">
        <div>
          <h1>{t("main.aboutUs.heroTitle")}</h1>
          <span />
        </div>
      </section>

      <section className="about-content">
        <div className="about-section about-history">
          <h2>{t("main.aboutUs.historyTitle")}</h2>

          <div className="history-grid">
            <div className="history-text">
              <p>{t("main.aboutUs.historyText1")}</p>
              <p>{t("main.aboutUs.historyText2")}</p>
              <p>{t("main.aboutUs.historyText3")}</p>
            </div>

            <div className="history-image">
              <img src={teamPhoto} alt={t("main.aboutUs.teamAlt")} />
            </div>
          </div>
        </div>

        <section className="mission-vision-card">
          <div className="mv-item">
            <h3>{t("main.aboutUs.missionTitle")}</h3>
            <p>{t("main.aboutUs.missionText")}</p>
          </div>

          <div className="mv-divider" />

          <div className="mv-item">
            <h3>{t("main.aboutUs.visionTitle")}</h3>
            <p>{t("main.aboutUs.visionTextNew")}</p>
          </div>
        </section>

        <section className="values-card">
          <h2>{t("main.aboutUs.valuesTitle")}</h2>

          <div className="values-grid">
            {values.map((value) => (
              <article className="value-item" key={value.title}>
                {value.icon ? <img className="value-icon" src={value.icon} alt="" /> :
                  <div className="value-icon sustainability-icon" aria-hidden="true">
                    <img src={sustainabilityCenter} alt="" /><img src={sustainabilityRight} alt="" /><img src={sustainabilityLeft} alt="" />
                  </div>}
                <h4>{value.title}</h4>
                <p className="value-copy-desktop">{value.text}</p>
                <p className="value-copy-mobile">{value.mobileText}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="group-section">
          <h2>{t("main.aboutUs.groupTitle")}</h2>

          <GroupChart />
        </section>

        <section className="companies-grid">
          <article className="company-card">
            <img src={rigsaveCapitalLogo} alt="Rigsave Capital" />
            <p>{t("main.aboutUs.rigsaveCapitalAboutUs")}</p>
          </article>


        </section>

        <section className="board-section">
          <h2>{t("main.aboutUs.director_board")}</h2>

          <div className="governance-grid">
            <div>
              <strong>Giovanni Gervasi</strong>
              <span>{t("main.aboutUs.roles.chairman")}</span>
            </div>

            <div>
              <strong>Andrea Polzot</strong>
              <span>{t("main.aboutUs.roles.ceo")}</span>
            </div>

            <div>
              <strong>Doriano Giambarda</strong>
              <span>{t("main.aboutUs.roles.boardMember")}</span>
            </div>
          </div>
        </section>

        <section className="governance-section">
          <h2>{t("main.aboutUs.governanceTitle")}</h2>

          <div className="governance-grid">
            <div>
              <strong>18,21%</strong>
              <span>Salvatore Gervasi</span>
            </div>

            <div>
              <strong>18,28%</strong>
              <span>Michele Basilicata</span>
            </div>

            <div>
              <strong>17,80%</strong>
              <span>Rossana Ruffo</span>
            </div>

            <div>
              <strong>17,56%</strong>
              <span>Tonino Gervasi</span>
            </div>
          </div>
        </section>

        <section className="auditory-section">
          <h2>{t("main.aboutUs.statory_auditors")}</h2>

          <div className="auditory-grid">
            <div>
              <strong>{t("main.aboutUs.president")}</strong>
              <span>Vincenzo Atzori</span>
            </div>

            <div>
              <strong>{t("main.aboutUs.effective_member")}</strong>
              <span>Luca Laurini</span>
            </div>

            <div>
              <strong>{t("main.aboutUs.effective_member")}</strong>
              <span>Stefan Colao</span>
            </div>

            <div>
              <strong>{t("main.aboutUs.sub_member")}</strong>
              <span>Silvia Molino</span>
            </div>

            <div>
              <strong>{t("main.aboutUs.sub_member")}</strong>
              <span>Davide Barbieri</span>
            </div>
          </div>
        </section>
        <section id="download-list" className="download-list">
          <h2>{t("main.footer.legalCompliance")}</h2>
          {files.map((doc) => (
            <a
              key={doc.key}
              href="/"
              aria-label={`${t("main.common.download")} ${doc.name}`}
              onClick={(event) => openS3Document(event, doc.key)}
            >
              <span>{doc.name}</span>
              <FiDownload />
            </a>
          ))}
        </section>

      </section>
    </main>
  );
}

export default AboutUs;